import { Background } from './components/Background';
import { Bento } from './components/Bento';
import { Contact } from './components/Contact';
import { Experience } from './components/Experience';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { Nav } from './components/Nav';
import { ScrollProgress } from './components/ScrollProgress';
import { SidePanels } from './components/SidePanels';
import { Skills } from './components/Skills';

import { useClock } from './hooks/useClock';
import { useCursor } from './hooks/useCursor';
import { useReveal } from './hooks/useReveal';
import { useScrollProgress } from './hooks/useScrollProgress';
import { useTheme } from './hooks/useTheme';

import { author } from './data/profile';

import './styles/tokens.css';
import './styles/globals.css';
import './styles/sections.css';

function App() {
  const { theme, toggle: toggleTheme } = useTheme();
  const time = useClock({ timeZone: author.timezone });

  useReveal();
  useCursor();
  useScrollProgress();

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <Background />
      <ScrollProgress />
      <Nav theme={theme} onToggleTheme={toggleTheme} />

      <main className="page" id="main">
        <Hero time={time} />
        <Bento />
        <Experience />
        <Skills />
        <SidePanels />
        <Contact />
      </main>

      <Footer time={time} />
    </>
  );
}

export default App;
